/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';

import { ICONS } from '../../../../utils/styles';
import {
  Name,
  Email,
  StyledIcon,
  StyledIconX,
  IconContainer,
  InfoContainer
} from './styled-components';
import { Box, Flex } from '../ui';

const Wrapper = styled(Flex)`
  flex: 1;
  width: 100%;
  max-width: 90%;
  align-items: center;
  cursor: pointer;
`;

const AccountCard = ({
  email,
  hasTokens,
  name,
  onClick,
  noHover,
  simple,
  firstName,
  removeAccount,
  ...props
}) => (
  <Wrapper
    onClick={() => onClick({ firstName, email })}
    className={noHover ? '' : 'hover'}
    {...props}
  >
    <Box style={{ flex: '0 0 auto' }}>
      <IconContainer>
        <StyledIcon width={40} height={40} color="#2d5696" icon={ICONS.DEFAULT_USER} />
      </IconContainer>
    </Box>
    <Box style={{ flex: '0 0 auto', marginLeft: '1em' }}>
      <InfoContainer>
        <div>
          {simple || !name ? <Name>{email || 'Use Another Account'}</Name> : <Name>{name}</Name>}
        </div>
        <div>{!simple && name && <Email>{email}</Email>}</div>
      </InfoContainer>
    </Box>
    {removeAccount && (
      <Box style={{ marginLeft: 'auto' }}>
        <StyledIconX
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            removeAccount(email);
          }}
          color="#2d5696"
          icon={ICONS.X}
        />
      </Box>
    )}
  </Wrapper>
);

AccountCard.defaultProps = {
  name: null,
  email: null,
  hasTokens: false,
  noHover: false,
  firstName: null,
  onClick: () => null,
  removeAccount: null,
  simple: false,
  customStyle: {}
};

export default AccountCard;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/AccountCard/index.js